import React from 'react'

import { Box, Grid, Typography, Tooltip, makeStyles } from '@material-ui/core'

import PropTypes from 'prop-types'
import clsx from 'clsx'

import styles from './styles'

const useStyles = makeStyles(styles)

const Label = ({
  children,
  ellipsis,
  title = '',
  description = '',
  className,
  titleClassName,
  titleVariant = 'subtitle2',
  marginTopChildren = 1,
  descriptionVariant = 'caption',
  paddingBoxTitle = 1,
  useTooltip = true,
  containerProps = {},
  error = false,
  ...rest
}) => {
  const classes = useStyles()

  return (
    <Grid
      {...rest}
      className={clsx(
        {
          [classes.ellipsis]: ellipsis,
        },
        classes.root,
        className,
      )}
    >
      <Box>
        {title && (
          <Box py={paddingBoxTitle}>
            <Typography
              variant={titleVariant}
              className={clsx({
                [titleClassName]: !!titleClassName,
                [classes.error]: error,
              })}
              color="textPrimary"
            >
              {title}
            </Typography>
          </Box>
        )}
        {description &&
          (useTooltip ? (
            <Tooltip title={description || ''} placement="bottom-start">
              <Typography
                variant={descriptionVariant}
                color="textSecondary"
                className={classes.typography}
              >
                {description}
              </Typography>
            </Tooltip>
          ) : (
            <Typography
              variant={descriptionVariant}
              color="textSecondary"
              className={classes.typography}
            >
              {description}
            </Typography>
          ))}
      </Box>
      <Box mt={marginTopChildren} {...containerProps}>
        {children}
      </Box>
    </Grid>
  )
}

Label.propTypes = {
  children: PropTypes.node,
  ellipsis: PropTypes.string,
  title: PropTypes.node,
  description: PropTypes.node,
  className: PropTypes.string,
  titleVariant: PropTypes.string,
  descriptionVariant: PropTypes.string,
  paddingBoxTitle: PropTypes.number,
  marginTopChildren: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  titleClassName: PropTypes.string,
  error: PropTypes.bool,
}

export default Label
